import React, { FC } from "react";
import AudioPlayer from "Components/AudioPlayer";
import { useSelector, useDispatch } from "react-redux";

import {
  setAudio,
  playAudio,
  pauseAudio,
  setProgress,
} from "./AudioPlayerActions";

interface Props {
  url: String;
  icon: any;
  pauseIcon?: any;
}

const AudioPlayerContainer: FC<Props> = (props: Props) => {
  const { url, icon, pauseIcon } = props;
  const Dispatch = useDispatch();

  const { audio, isPlaying, progress } = useSelector(
    (state: any) => state.audioPlayer
  );

  if (audio && !isPlaying && progress === 0) {
    audio.stop();
  }

  return (
    <AudioPlayer
      url={url}
      icon={icon}
      pauseIcon={pauseIcon}
      audio={audio}
      setAudio={(audioFlow: any) => Dispatch(setAudio(audioFlow))}
      isPlaying={isPlaying}
      progress={progress}
      setProgress={(val: any) => Dispatch(setProgress(val))}
      playAudio={() => Dispatch(playAudio())}
      pauseAudio={() => Dispatch(pauseAudio())}
    />
  );
};

AudioPlayerContainer.defaultProps = {
  pauseIcon: null,
};

export default AudioPlayerContainer;
